import { Outlet } from 'react-router-dom';
import { AuthGate } from './AuthGate';
import { TopBar } from './TopBar';

export function AppShell() {
  return (
    <AuthGate>
      <div className="min-h-screen bg-surface">
        <TopBar />
        <Outlet />
      </div>
    </AuthGate>
  );
}
